var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "section", attrs: { id: "yhteystiedot" } },
    [
      _c("h2", { staticClass: "section__heading section__heading--alt2" }, [
        _vm._v("\n    Asiakkaan yhteystiedot\n  ")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "checkout__rows" }, [
        _c("div", { staticClass: "checkout__header" }, [
          _c(
            "div",
            { staticClass: "cart__search" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm.$store.getters.changesAllowed
                ? _c("CheckoutClientSearch", {
                    attrs: { nonce: _vm.nonce },
                    on: {
                      change: function($event) {
                        return _vm.customerChanged($event)
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._v(" "),
        _vm.customer.billing && _vm.customer.billing.company_id
          ? _c("div", { staticClass: "checkout__subsection" }, [
              _vm.customer.warn_text
                ? _c("div", { staticClass: "error-notification" }, [
                    _c("p", [
                      _vm._v("Varoitus: " + _vm._s(_vm.customer.warn_text))
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "checkout__offer-client" }, [
                _c(
                  "p",
                  [
                    _vm.customer.billing.company
                      ? _c("strong", [
                          _vm._v(_vm._s(_vm.customer.billing.company)),
                          _c("br")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.customer.billing.company_id
                      ? [
                          _vm._v(
                            "\n            Y-tunnus: " +
                              _vm._s(_vm.customer.billing.company_id)
                          ),
                          _c("br")
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.customer.billing.customer_code
                      ? [
                          _vm._v(
                            "\n            Asiakasnumero: " +
                              _vm._s(_vm.customer.billing.customer_code)
                          ),
                          _c("br")
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.customer.paydeal
                      ? [
                          _vm._v(
                            "\n            Maksuehto: " +
                              _vm._s(_vm.customer.paydeal) +
                              " päivää"
                          ),
                          _c("br")
                        ]
                      : _vm._e()
                  ],
                  2
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("label", { attrs: { for: "customer_company" } }, [
                  _vm._v("Yrityksen nimi")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customer.billing.company,
                      expression: "customer.billing.company"
                    }
                  ],
                  attrs: {
                    id: "customer_company",
                    type: "text",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.customer.billing.company },
                  on: {
                    change: _vm.localCustomerStateChanged,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.customer.billing,
                        "company",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--float" }, [
                _c("label", { attrs: { for: "customer_first_name" } }, [
                  _vm._v("Etunimi")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customer.billing.first_name,
                      expression: "customer.billing.first_name"
                    }
                  ],
                  attrs: {
                    id: "customer_first_name",
                    type: "text",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.customer.billing.first_name },
                  on: {
                    change: _vm.localCustomerStateChanged,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.customer.billing,
                        "first_name",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("label", { attrs: { for: "customer_last_name" } }, [
                  _vm._v("Sukunimi")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customer.billing.last_name,
                      expression: "customer.billing.last_name"
                    }
                  ],
                  attrs: {
                    id: "customer_last_name",
                    type: "text",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.customer.billing.last_name },
                  on: {
                    change: _vm.localCustomerStateChanged,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.customer.billing,
                        "last_name",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field field--float" }, [
                _c("label", { attrs: { for: "customer_email" } }, [
                  _vm._v("Sähköposti")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customer.billing.email,
                      expression: "customer.billing.email"
                    }
                  ],
                  attrs: {
                    id: "customer_email",
                    type: "email",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.customer.billing.email },
                  on: {
                    change: _vm.localCustomerStateChanged,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.customer.billing,
                        "email",
                        $event.target.value
                      )
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "field" }, [
                _c("label", { attrs: { for: "customer_phone" } }, [
                  _vm._v("Puhelin")
                ]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.customer.billing.phone,
                      expression: "customer.billing.phone"
                    }
                  ],
                  attrs: {
                    id: "customer_phone",
                    type: "tel",
                    disabled: !_vm.$store.getters.changesAllowed
                  },
                  domProps: { value: _vm.customer.billing.phone },
                  on: {
                    change: _vm.localCustomerStateChanged,
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.customer.billing,
                        "phone",
                        $event.target.value
                      )
                    }
                  }
                })
              ])
            ])
          : _c("div", { staticClass: "checkout__subsection" }, [
              _c("div", { staticClass: "checkout__subsection__empty" }, [
                _vm._v("\n        Ei valittua asiakasta\n      ")
              ])
            ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "label",
      { staticClass: "cart__search__label", attrs: { for: "client-search" } },
      [
        _c("h3", { staticClass: "checkout__header__heading" }, [
          _vm._v("Asiakas")
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81209934", { render: render, staticRenderFns: staticRenderFns })
  }
}